<script>

let url = new URL(window.location);
let params = new URLSearchParams(url.search);
let panelParam = params.get('panel');
let rangeParam = params.get('ranges');
let modelParam = params.get('model');

export default {

  name: 'VueWhereToView',

  mounted(){
    this.fetchData();
  },

  data() {

    return {
        isLoading: true,

        allParks: [],
        allRegions: [],
        allRanges: [],
        allModels: [],

        availableParks:[],
        availableModels:[],

        selectedRegion: 'All Regions',
        selectedRegionItems:[],

        selectedRange: 'Select Range',
        selectedRangeItems:[],

        selectedModel: 'Select Model',
        selectedModelItems: [],

        selectedPanel: 'region',

        showRegionPanel: true,
        showProductPanel: false,

        openedMarkerID: null,
        icon: {
          url: `/wp-content/themes/pemberton/assets/images/map-pin.png`,
          scaledSize: {
            height: 50,
            width: 34
          },
        },
        center: { lat: 54.3781, lng: -3.75},
      }
    },

  methods: {

    fetchData: async function() {

      // Helper function to fetch all paginated data
      const fetchAllPages = async (url, perPage = 100) => {
        let allData = [];
        let page = 1;
        let data;

        do {
          const response = await fetch(`${url}?per_page=${perPage}&page=${page}`);
          data = await response.json();
          allData = allData.concat(data);
          page++;
        } while (data.length === perPage);  // Continue if we have more pages

        return allData;
      };

      // Fetch regions
      const regions = await fetchAllPages('/wp-json/wp/v2/region', 99);
      regions.forEach(item => {
        this.allRegions.push(item);
        this.selectedRegionItems.push(item);
      });

      // Fetch ranges
      const ranges = await fetchAllPages('/wp-json/wp/v2/ranges', 99);
      ranges.forEach(item => {
        this.allRanges.push(item);
        this.selectedRangeItems.push(item);
      });

      // Fetch products
      const products = await fetchAllPages('/wp-json/pemberton/v1/products', 100);
      products.forEach(item => {
        this.allModels.push(item);
        this.selectedModelItems.push(item);
      });

      // Fetch parks
      const parks = await fetchAllPages('/wp-json/wp/v2/parks', 99);
      parks.forEach(item => {
        this.allParks.push(item);
        this.availableParks.push(item);
      });

      // When all data is fetched, handle loading and query string processing
      this.queryStringGetter();
      this.isLoading = false;
    },



    // Shuffle parks

    shuffleArray: function(array) {
      for (var i = array.length - 1; i > 0; i--) {

        var j = Math.floor(Math.random() * (i + 1));

        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }

      return array;
    },



    // URL Setter
    queryStringSetter: function(key, value) {
      params.set(key, value);
      window.history.replaceState({}, '', `${location.pathname}?${params}`);
    },


    // URL Setter
    queryStringGetter: async function() {
      let regionParam = params.get('region');

      if(panelParam) {
        this.selectedPanel = panelParam;
      }

      if(regionParam) {

        this.selectedRegion = regionParam;
        this.availableParks = this.allParks.filter(item => item?.acf?.region?.name === regionParam);
      }

      if(rangeParam) {
        this.selectedRange = rangeParam;
        this.availableParks = this.allParks.filter(item => item?.acf?.stock?.some(item => item?.acf?.range?.name?.includes(this.selectedRange)))
        this.availableModels = this.allModels.filter(item => item.range === this.selectedRange)

      }

      if(modelParam) {
        this.selectedModel = modelParam;

        this.availableModels = this.allModels.filter(item => item.range === this.selectedRange)
        this.availableParks = this.allParks.filter(item => item?.acf?.stock?.some(item => item.ID === this.selectedModel && (item?.acf?.range?.name === this.selectedRange || this.selectedRange === 'Select Range')))


      }

      window.history.replaceState({}, '', `${location.pathname}?${params}`);
    },


    handleRegionSelect: function(event) {
      event.target.value !== 'All Regions'
        ? this.availableParks = this.allParks.filter(item => item?.acf?.region?.name === event.target.value)
        : this.availableParks = this.allParks;

      this.queryStringSetter('region', event.target.value)
    },


    handleRangeSelect: function(event) {

      if(event.target.value !== 'Select Range') {
       this.selectedModel = 'Select Model';
       this.availableModels = this.allModels.filter(item => item?.range === this.selectedRange)
       this.availableParks = this.allParks.filter(item => item?.acf?.stock?.some(item => item?.acf?.range?.name?.includes(event.target.value)))
      } else {
       this.availableParks = this.allParks;
       this.availableModels = this.allModels;
      }

       this.queryStringSetter('ranges', event.target.value);
    },

    handleModelSelect: function(event) {

      event.target.value !== 'Select Model'
        ? this.availableParks = this.allParks.filter(item => item?.acf?.stock?.some(item => item.ID === event.target.value && (item?.acf?.range?.name === this.selectedRange || this.selectedRange === 'Select Range')))
        : this.availableParks = this.allParks;

       this.queryStringSetter('model', event.target.value);
    },

    handlePanelToggle: function(event) {
      this.selectedPanel = event.target.value;

      this.selectedRegion = 'All Regions';
      this.availableParks = this.allParks;
      this.availableModels = this.allModels;

      this.selectedRange = 'Select Range';
      this.selectedModel = 'Select Model';

      params.delete('region');
      params.delete('model');
      params.delete('ranges');

      this.queryStringSetter('panel', event.target.value)
    },

    openMarker(id) {
       this.openedMarkerID = id
    }

  },
}

</script>


<template>
  <div class="section-wrapper background-grey">
    <section>

      <div class="loader-wrapper" v-if="isLoading">
        <div class="loader"></div>
      </div>

      <div v-if="!isLoading">

      <div class="button-wrapper centered tabs">
        <button @click="this.handlePanelToggle" value="region" :class="this.selectedPanel == 'region' ? 'button flag is-active' : 'button flag'">Find your Park</button>
        <button @click="this.handlePanelToggle" value="model" :class="this.selectedPanel == 'model' ? 'button flag is-active' : 'button flag'">Find by Model</button>
        <!-- <button @click="this.handlePanelToggle" value="ranges" :class="this.selectedPanel == 'ranges' ? 'button flag is-active' : 'button flag'">Find by Range</button> -->

      </div>

      <div class="tabs-select-wrapper">

      <div class="tabs-select" v-show="this.selectedPanel == 'region'">
        <div class="select-wrapper">
          <select @change="this.handleRegionSelect" v-model="this.selectedRegion">
            <option value="All Regions" selected>All Regions</option>
            <option v-for="(region, index) in allRegions" :key="region.id" :value="region.name">{{region.name}}</option>
          </select>
        </div>
      </div>

      <div class="tabs-select" v-show="this.selectedPanel == 'model'">

        <div class="select-wrapper">
          <select @change="this.handleRangeSelect" v-model="this.selectedRange">
            <option value="Select Range" selected disabled>Select Range</option>
            <option v-for="(range, index) in allRanges" :key="range.id" :value="range.name">{{range.name}}</option>
          </select>
        </div>


        <div class="select-wrapper" v-show="this.selectedPanel == 'model'">
          <select @change="this.handleModelSelect" v-model="this.selectedModel" :disabled="this.selectedRange == 'Select Range'">
            <option value="Select Model" selected disabled>Select Model</option>
            <option v-for="(model, index) in availableModels" :key="model.id" :value="model.id">{{model.range + ' - ' + model.name}}</option>
          </select>
        </div>

          <!-- <div class="select-wrapper">
          <select @change="this.handleRangeSelect" v-model="this.selectedRange">
            <option value="Select Range" selected>Select Range</option>
            <option v-for="(range, index) in allRanges" :key="range.id" :value="range.name">{{range.name}}</option>
          </select>
        </div> -->

        </div>



        <a href="#results" class="read-more-link">View your results below</a>

      </div>


    <GMapMap
      :center="center"
      :zoom="5.5"
      map-type-id="roadmap"
      style="width: 100%; margin: 1rem 0; height: 35rem; border.5rem;"
    >


    <GMapMarker
      :key="index"
      v-for="(park, index) in availableParks"
      :position="{lat: parseFloat(park.acf.lat), lng: parseFloat(park.acf.lng)}"
      :icon="{
        url: icon.url,
        scaledSize: icon.scaledSize
      }"
      :clickable="true"
      :draggable="false"
      @click="openMarker(park.id)"
    >

    <GMapInfoWindow
      :closeclick="true"
      :opened="openedMarkerID === park.id"
    >
      <div style="max-width: 10rem; line-height: 1.75;">
        <h3 style="margin: 0 0 .5rem 0;" v-html="park.title.rendered"></h3>
        {{park.acf.address}}
      </div>
    </GMapInfoWindow>


    </GMapMarker>



    </GMapMap>


    <div id="results">

      <div class="section-header-inline<?php if($first_subheading || $second_subheading || $heading) { echo ' divider';}?>">
        <div class="section-header-content">
          <p class="section-subheading">Your results</p>
          <h2 class="section-heading">{{availableParks.length}} parks</h2>
        </div>
      </div>

      <ul class="cardList">
        <li class="cardList-item park" v-for="(park, index) in availableParks" :key="park.id">
          <div class="cardList-item-inner">
            <div class="cardList-item-content-wrapper">
              <div>

          <a :href="park.link" v-if="park.acf?.gallery" class="cardList-item-image-link">
            <div class="cardList-item-image-wrapper">
              <img class="cardList-item-image" :src="park.acf.gallery[0]?.sizes.medium_large"/>
            </div>
          </a>


          <div class="cardList-item-content">
          <h2><a :href="park.link" v-html="park.title.rendered"></a></h2>
          <p><strong>LOCATION:</strong> {{park.acf.address}} <a class="read-more-link" :href="park.link">About this park</a></p>

          <div class="cardList-item-stock" v-if="park.acf.stock">
            <h3>Models available to view:</h3>
            <ul class="unstyled-list check-list">
              <li class="checklist-item" v-for="(stock, index) in park.acf.stock" :key="stock.id">
                  <!-- {{stock.acf?.range?.name ? stock.acf?.range?.name + ', ' : ''}} -->
                  {{stock.acf?.year?.name ? stock.acf?.year?.name + ', ' : ''}}
                  {{stock.post_title ? stock.post_title + ', ' : ''}}
                  <!-- {{stock.acf?.bedrooms?.name ? stock.acf?.bedrooms?.name + ' bedrooms' : ''}} -->

              </li>
            </ul>

          </div>

          </div>
        </div>

          <div class="button-wrapper">
            <a :href="park.link" class="button">More info</a>
            <!-- <button class="button">Where to view</button> -->
          </div>

        </div>
          </div>
        </li>
      </ul>

    </div>

    </div>

    </section>
  </div>
</template>
